<template>
  <div class="claim-form-step" data-test-id="claim-form-step">
    <div class="claim-form-step__copy">
      <Typography variant="h-5">Add a claim form</Typography>
      <Typography variant="body-1">
        Select the form participants will use to submit a claim. Forms are managed separately in the
        admin — if you haven't built one yet, you'll need to do that before continuing.
      </Typography>
    </div>
    <v-form ref="form">
      <v-select
        outlined
        color="brandPrimary"
        label="Claim Form*"
        :items="formOptions"
        :loading="loadingForms"
        item-text="text"
        item-value="value"
        hide-details="auto"
        :value="formId"
        :rules="formIdRules"
        @input="onFormSelected"
      />
    </v-form>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "ClaimFormStep",
  components: {
    Typography,
  },
  props: {
    formId: {
      type: Number,
      default: null,
    },
    forms: {
      type: Array,
      default: () => [],
    },
    loadingForms: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:formId"],
  data() {
    return {
      formIdRules: [(v) => v != null || "Please select a claim form"],
    };
  },
  computed: {
    formOptions() {
      const options = this.forms.map((form) => ({
        value: Number(form.formId),
        text: form.name || `Form ${form.formId}`,
      }));
      if (this.formId != null && !options.some((option) => option.value === this.formId)) {
        options.unshift({ value: this.formId, text: `Form ${this.formId}` });
      }
      return options;
    },
  },
  methods: {
    onFormSelected(formId) {
      this.$emit("update:formId", formId == null ? null : Number(formId));
    },
    validate() {
      return this.$refs.form?.validate() ?? false;
    },
  },
};
</script>

<style scoped>
.claim-form-step {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.claim-form-step__copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
